import classNames from 'classnames';
import { forwardRef, type HTMLAttributes, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type SkeletonProps = Pick<HTMLAttributes<HTMLDivElement>, 'className' | 'style'> & {
  height?: number | string;
  width?: number | string;
  isText?: boolean;
  variant?: 'round' | 'square';
};

export const Skeleton = memo(
  forwardRef<HTMLDivElement, SkeletonProps>(
    ({ className, height, isText, width, style, variant = 'square' }: SkeletonProps, ref) => {
      return (
        <div
          className={cn('box-border text-grey-3', isText ? 'py-0.5' : undefined, className)}
          data-testid="SKELETON"
          ref={ref}
          style={{
            height,
            width,
            ...style,
          }}
        >
          <div
            className={classNames('box-border h-full w-full animate-pulse bg-current', {
              'rounded-2': variant === 'square',
              'rounded-full': variant === 'round',
            })}
            data-variant={variant}
            style={{
              animationFillMode: 'forwards',
              backgroundPositionX: '100%',
              backgroundSize: '200px 100%',
            }}
          />
        </div>
      );
    },
  ),
);

Skeleton.displayName = 'Skeleton';
